"use client";
import { useCallback as u } from "react";
const l = (t, e, a) => u(
  (r) => {
    if (e || a) {
      r.preventDefault();
      return;
    }
    t == null || t(r);
  },
  [a, e, t]
);
export {
  l as default
};
